import React from 'react';
import { capitalize } from 'lodash';
import { DOCUMENT_TYPE_LABEL } from './constants';

const getUserTitle = revision => {
  if (revision.User) {
    return (
      <span data-dd-privacy="mask" className="amp-mask">
        {capitalize(revision.User.firstName)}{' '}
        {capitalize(revision.User.lastName)}
      </span>
    );
  }

  return <span>Unknown User</span>;
};

/**
 * Generate a title for revision;
 */
export const getTitle = revision => {
  const user = getUserTitle(revision);

  // Replace document type with readable names
  const { documentType, operation } = revision;
  const documentTypeLabel = DOCUMENT_TYPE_LABEL[documentType] || documentType;

  return (
    <div className="title">
      {user} {operation}d{' '}
      <b>
        {documentTypeLabel} (ID: {revision.documentId})
      </b>
      .
    </div>
  );
};
